import React, { useEffect, useState } from 'react';
import SplashScreen from './components/SplashScreen';
import MainLanding from './components/MainLanding';
export function App() {
  const [showSplash, setShowSplash] = useState(true);
  useEffect(() => {
    // Timer to automatically transition from splash to main landing
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 5000); // 5 seconds for the complete splash animation
    return () => clearTimeout(timer);
  }, []);
  return <div className="w-full min-h-screen" data-id="element-0">
      {showSplash ? <SplashScreen data-id="element-1" /> : <MainLanding data-id="element-2" />}
    </div>;
}